const QuizPublicationPublishManage = resolve =>
  require(['src/views/publication/QuizPublicationPublishManage'], resolve)
// const LibQuestionManage = resolve => require([ 'src/views/quiz/LibQuestionManage' ], resolve)
const PublicationModule = resolve =>
  require(['src/views/publication/PublicationModule'], resolve)
const PublicationLibList = resolve =>
  require(['src/views/publication/PublicationLibList'], resolve)
// const LibListModule = resolve => require(['src/views/quiz/LibListModule.vue'], resolve)
const LibIndex = resolve => require(['src/views/quiz/LibIndex.vue'], resolve)
const LibModule = resolve => require(['src/views/quiz/LibModule.vue'], resolve)
// const LibBasicManage = resolve => require([ 'src/views/quiz/LibBasicManage.vue' ], resolve)
const LibCreate = resolve => require(['src/views/quiz/LibCreate'], resolve)
// const LibAwardManage = resolve => require([ 'src/views/quiz/LibAwardManage' ], resolve)
const ReportPage = resolve =>
  require(['src/views/report/quiz/quizReport'], resolve)
// Setting
const SettingPage = resolve => require(['src/views/setting/Setting'], resolve)
const PromotionPage = resolve =>
  require(['src/views/promotion/promotion'], resolve)

const quizPublicationRouter = {
  path: '/quiz/:publicationId',
  component: PublicationModule,
  children: [
    // quiz 的页面
    {
      name: '题库',
      path: '/quiz/:publicationId/',
      component: PublicationLibList,
    },
    {
      name: '题库分析',
      path: '/quiz/:publicationId/report',
      component: ReportPage,
    },
    {
      name: '题库设置',
      path: '/quiz/:publicationId/setting',
      component: SettingPage,
    },
    {
      name: '题库推广',
      path: '/quiz/:publicationId/promotion',
      component: PromotionPage,
    },
    {
      name: '题库创建',
      path: '/quiz/:publicationId/lib/create',
      component: LibCreate,
    },
    {
      name: '题库发布',
      path: '/quiz/:publicationId/publish',
      component: QuizPublicationPublishManage,
    },
    {
      path: '/quiz/:publicationId/lib/:libId',
      component: LibModule,
      children: [
        {
          path: '/quiz/:publicationId/lib/:libId/',
          component: LibIndex,
        },
      ],
    },
  ],
}

export default quizPublicationRouter
